<div class="w-full max-w-container
            flex flex-wrap
            mt-[2.813rem] mb-12
            md:mt-[7.188rem]
            justify-between mx-auto">
  <div class="w-full mx-auto
              flex flex-col
              p-[0.938rem]
              gap-2 md:text-center">
    <div class="w-full text-2xl
                leading-[2.25rem]
                md:text-[2.375rem]
                md:leading-[3.563rem]
                text-darker font-semibold">
      Wat maken we schoon bij een {{ package | capitalizeFirst }}?
    </div>

    <div class="h-1 w-32
                bg-divider md:mx-auto
                mt-[0.9rem] md:my-[1rem]"></div>
  </div>

    <div class="w-full max-w-container
                my-6 md:my-12
                md:px-[0.938rem] md:mx-auto">
      <div class="w-full md:mx-auto
                  py-[0.938rem] text-center
                  bg-secondary md:rounded-full
                  shadow text-primary
                  overflow-x-auto
                  flex flex-1 flex-nowrap
                  items-center md:justify-evenly">
        <div *ngFor="let roomType of details?.roomDetails"
             (click)="currentDetails = roomType"
             class="w-[18.625rem] font-semibold
                    text-gray text-xl
                    capitalize whitespace-nowrap
                    cursor-pointer relative
                    hover:ripple
                    hover:text-[#004494]
                    even:border-x
                    first:border-l-0
                    last:!border-r-0
                    px-[0.938rem] py-2"
             [ngClass]="{ 'active-arrow-tab': currentDetails?.name === roomType?.name}">
          <div class="arrow">
            {{ roomType?.name }}
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="currentDetails"
         class="w-full my-[4.688rem] grid_masonry justify-center"
         [class.flex]="currentDetails.details.length === 2"
         [ngStyle]="{'--masonry-columns': getColumns(currentDetails.details.length)}">
      <div *ngFor="let item of currentDetails?.details"
           class="masonry-item mx-auto
                  md:mx-0 max-w-[28.125rem]
                  py-4 px-[0.938rem]">
        <div class="w-full h-fit
                    max-w-[28.125rem]
                    mx-auto md:mx-0
                    flex flex-col
                    gap-4 relative p-6
                    shadow-md shadow-light-gray
                    bg-secondary rounded-lg">
          <div class="h-12 w-12
                      bg-primary absolute
                      -top-2 -right-2
                      flex justify-center
                      items-center
                      rounded-2xl p-2.5">
            <img class="m-auto"
                 src="assets/icons/{{getImg(item?.title)}}.svg"
                 alt="gs"/>
          </div>

          <div class="text-lg capitalize
                      text-darker font-semibold">
            {{ item?.title }}
          </div>

          <div class="w-full flex
                      flex-col gap-4">
            <div *ngFor="let task of item?.info"
                 class="w-full flex gap-2">
              <img src="assets/icons/bullet.svg" alt="bullet"/>

              <span class="text-sm text-darker">
                  {{ task }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
